import { useQuery } from "@tanstack/react-query";
import { fetchSubProfile } from "utils/api";

export const useSubProfile = (subId: string) => {
  const { data: subProfile } = useQuery({
    enabled: !!subId,
    queryKey: ["subs", subId],
    queryFn: async () => {
      const { data } = await fetchSubProfile(subId);
      return data;
    },
  });
  return subProfile;
};
